import { Fragment } from "react";
import { Link } from "react-router-dom";
import "./css/footer.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import LogoHyundai from "../../images/assets/hyundai-logo-white.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Footer() {
  return (
    <Fragment>
      <footer className="py-3 py-md-5">
        <Container >
          <Row>
            <Col md={3} className="mt-2 mt-md-0 ml-2 ml-md-0">
              <Link to="/">
                <figure className="footer-logo">
                  <LazyLoadImage
                    src={LogoHyundai}
                    alt="Logo de Hyundai Vehiculos - Inicio"
                    className="img-logo"
                  />
                </figure>
                <span className="sr-only">Inicio - Hyundai Vehiculos</span>
              </Link>
            </Col>
            <Col md={3} className="justify-content-center mt-3 mt-md-0">
              <ul>
                {/*<li>
                  <Link to="/terminos-y-condiciones" className="text-reset">
                    Términos y condiciones
                  </Link>
                </li>*/}
                <li>
                  <Link to="/politica-privacidad" className="text-reset">
                    Políticas de privacidad
                  </Link>
                </li>
                <li>
                  <Link to="/mercado-valores" className="text-reset">
                    Mercado de valores
                  </Link>
                </li>
                <li>
                  <Nav.Link
                    href="https://hyundai.com.ec/static/media/proteccion.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-reset "
                    style={{ marginLeft: -15 }}
                  >
                    Política de protección de datos personales
                  </Nav.Link>
                </li>
                <li>
                  <Nav.Link
                    href="resolucion-scvs-ircvsq.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-reset "
                    style={{ marginLeft: -15 }}
                  >
                    Resolución SCVS-IRCVSQ-DRMV-2024-00004025
                  </Nav.Link>
                </li>
                <li>
                  <Nav.Link
                    href="MUNDIAL_FIFA_2026.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-reset"
                    style={{ marginLeft: -15 }}
                  >
                    Sorteo Mundial FIFA 2026
                  </Nav.Link>
                </li>
              </ul>
            </Col>
            <Col md={3} className="justify-content-center mt-3 mt-md-0">
              <ul>
                <li>
                  <Nav.Link
                    href="politica-calidad-antisoborno.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-reset "
                    style={{ marginLeft: -15 }}
                  >
                    Política de calidad
                  </Nav.Link>
                </li>
                <li >
                  <Link to="/mision-vision" className="text-reset">
                    Misión y Visión
                  </Link>
                </li>
                <li>
                  <Nav.Link
                    href="https://hyundai.hiringroom.com/jobs"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-reset "
                    style={{ marginLeft: -15 }}
                  >
                    Trabaja con nosotros
                  </Nav.Link>
                </li>
                <li >
                  <Link to="/derecho-arco" className="text-reset">
                    Atención de derechos Arco+
                  </Link>
                </li>
                <li>
                  <Nav.Link
                    href="resumen-1pc-neohyundai.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-reset"
                    style={{ marginLeft: -15 }}
                  >
                    GLOBALRATINGS
                  </Nav.Link>
                </li>
                <li>
                  <Nav.Link
                    href="CONMEBOL.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-reset"
                    style={{ marginLeft: -15 }}
                  >
                    Términos y Condiciones Sorteo Final CONMEBOL Libertadores 2025
                  </Nav.Link>
                </li>
              </ul>
            </Col>
            <Col xs={12} md={3} className="text-center mt-3 mt-md-0">
              <div className="footer-social ">
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/HyundaiEcuador"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook Hyundai Ecuador"
                    >
                      <img src={"https://cdn-icons-png.flaticon.com/512/1384/1384005.png"}
                        alt="facebook"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/hyundaiecuadoroficial/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram Hyundai Ecuador"
                    >
                      <img src={"https://cdn-icons-png.flaticon.com/512/733/733558.png"}
                        alt="instragram"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.tiktok.com/@hyundaiec"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Tiktok Hyundai Ecuador"
                    >
                      <img src={"https://cdn-icons-png.flaticon.com/512/3046/3046121.png"}
                        alt="tiktok"
                      />
                    </a>
                  </li>
                  {/*
                      <li>
                        <a
                          href="https://twitter.com/HyundaiEcuador"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Twitter Hyundai Ecuador"
                        >
                          <img src={"https://cdn-icons-png.flaticon.com/512/5968/5968958.png"}
                            alt="twitter"
                          />
                        </a>
                      </li>
                      */}
                  <li>
                    <a
                      href="https://www.youtube.com/user/HYUNDAIECUADOR"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Youtube Hyundai Ecuador"
                    >
                      <img src={"https://cdn-icons-png.flaticon.com/512/733/733646.png"}
                        alt="youtube"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/hyundai-ecuador-b51992171"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Linkedin Hyundai Ecuador"
                    >
                      <img src={"https://cdn-icons-png.flaticon.com/512/733/733561.png"}
                        alt="linkedin"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            <div className="mt-3">
              <p className="footer-telefono text-white mb-0">
                <a href="tel:1800498632" className="text-white text-decoration-none">
                  <span style={{ fontSize: '20px' }}> ✆ </span> 1800 498632
                </a>
              </p>
            </div>
            {/*
                  <div className="d-flex align-items-center justify-content-center">
                    <a
                      href="https://wa.me/593989101113"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="WhatsApp Hyundai Ecuador"
                      height="40" 
                        width="40" 
                      className="d-flex align-items-center text-decoration-none"
                    >
                      <LazyLoadImage 
                        src={"https://cdn-icons-png.flaticon.com/512/733/733585.png"} 
                        alt="whatsapp" 
                        effect="opacity" 
                        height="20" 
                        width="20" 
                        className="mr-1"
                      />
                      <span className="mr-2" style={{fontSize: '25px'}}></span>
                      <p className="footer-telefono text-white mb-0">+593 989 101 113</p>
                    </a>
                  </div>
                  */}
          </Col>
        </Row>
        <Row>
          <Col md={12} className="text-center mt-3 mt-md-0">
            <p className="copyright texto-blanco">
              © 2021 Hyundai Motor Company del Ecuador. Todos los derechos
              reservados.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
    </Fragment >
  );
}
export default Footer;